export const filterValuePostfixes: Map<string, string> = new Map([
  ["rcu_reservation", "RCU"],
  ["wcu_reservation", "WCU"],
]);
